//This file contains all Firebase Configuration information including
//linking up to firebase.

import firebase from'firebase/app'; //Imports only the core functionality of firebase and not everything.
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';



// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCn3sXHDmCVtuPleaNZ-j7LHQZK7Jt0R2g",
  authDomain: "unlocked-academy-platform.firebaseapp.com",
  databaseURL: "https://unlocked-academy-platform.firebaseio.com",
  projectId: "unlocked-academy-platform",
  storageBucket: "unlocked-academy-platform.appspot.com",
  messagingSenderId: "621101157951",
  appId: "1:621101157951:web:ea3dc8a1eeed5e8572728a",
  measurementId: "G-C027DCCMS7"
};
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  const storage = firebase.storage();


  //firebase.firestore().settings({timestampsInSnapshots}) //This is no longer needed.

  
  export {
    storage, firebase as default
  }
  
